import SystemNeoUmmiaLogoTextImage from "../../images/SystemNeoUmmiaLogoTextImage";
import {useNavigate} from "react-router-dom";
import {internalRoutes} from "../../../constants/internalRoutes";

export default function AuthenticationTopBar() {
    // Used in

    // PROPERTIES
    const navigate = useNavigate();

    // BUILD
    return (
        <header className={"bg-backgroundLight1 w-full flex justify-start items-center h-[72px] min-h-[72px] px-[24px] border-b-[1px] border-gray-400"}>
            <SystemNeoUmmiaLogoTextImage onLogoPressed={() => navigate(internalRoutes.home)}
                                         extraClass={"mt-[2px]"}/>
        </header>
    );
}